import { useState } from "react";
import PropTypes from "prop-types";

import Content from "../Common/Content";

import { LoadingButton } from "../../../core/buttons";

function RemoveStudentList({
  list,
  onClick,
  removeStudents,
  secondTextContent,
}) {
  const firstText = (
    <span>
      You are removing
      {removeStudents === 1 ? " one student " : ` ${removeStudents} students `}
      from the list<span className="text-black"> "{list.name}"</span>.
    </span>
  );

  const [isLoading, setIsLoading] = useState(false);

  const handleOnClick = (event) => {
    event.preventDefault();
    setIsLoading(true);
    onClick();
  };

  return (
    <>
      <div className="px-1 flex flex-1 flex-col overflow-auto">
        <Content firstText={firstText} secondText={secondTextContent} />
      </div>
      <div className="py-5 flex flex-row">
        <LoadingButton
          isLoading={isLoading}
          onClick={handleOnClick}
          id="remove-student-remove-button"
          className="
            mb-5
            w-1/2
            ml-auto
            text-white
            bg-primary-blue
            border-primary-blue
            hover:bg-white
            active:bg-white
            hover:text-primary-blue
            active:text-primary-blue
            mobile:text-sm
            mobile-sm:text-sm
            tablet-sm:text-sm
          "
        >
          remove {removeStudents === 1 ? "student" : "students"}
        </LoadingButton>
      </div>
    </>
  );
}

RemoveStudentList.propTypes = {
  list: PropTypes.shape(),
  removeStudents: PropTypes.number,
  secondTextContent: PropTypes.any,
  onClick: PropTypes.func.isRequired,
};

export default RemoveStudentList;
